import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';

import { Iconify } from 'src/components/iconify';
import { CustomPopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

type ImportExportMenuProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  isImport: boolean;
  isExport: boolean;
  isActionButton: Array<'import' | 'export'>;
  handleImportClick: () => void;
  handleExport: () => void;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function ImportExportMenu({
  open,
  anchorEl,
  onClose,
  isImport,
  isExport,
  isActionButton,
  handleImportClick,
  handleExport,
  t,
}: ImportExportMenuProps) {
  return (
    <CustomPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{ arrow: { placement: 'right-top' } }}
    >
      <MenuList>
        {isActionButton.includes('import') && isImport && (
          <MenuItem
            onClick={() => {
              handleImportClick();
              onClose();
            }}
          >
            <Iconify icon="solar:import-bold" />
            {t('IMPORT')}
          </MenuItem>
        )}
        {isActionButton.includes('export') && isExport && (
          <MenuItem onClick={handleExport}>
            <Iconify icon="solar:export-bold" />
            {t('EXPORT')}
          </MenuItem>
        )}
      </MenuList>
    </CustomPopover>
  );
}
